namespace Nobox {
    export interface UserDefinition {
        Id?: string;
        DisplayName?: string;
        Email?: string;
        MobilePhoneNumber?: string;
        MobilePhoneVerified?: boolean;
        UserImage?: string;
        IsActive?: number;
        UserId?: number;
        Username?: string;
        PasswordHash?: string;
        PasswordSalt?: string;
        Source?: string;
        TimeZone?: string;
        Offset?: string;
        UpdateDate?: string;
        InsertDate?: string;
        LastDirectoryUpdate?: string;
        TwoFactorAuth?: Nobox.Administration.TwoFactorAuthType;
        TenantId?: number;
        Akses?: number;
        TglCreated?: string;
        Channels?: Nobox.Web.Modules.Administration.Tenant.Subscribe[];
        Storage?: Nobox.Web.Modules.Administration.Tenant.Subscribe;
        Support?: Nobox.Web.Modules.Administration.Tenant.Subscribe;
        Db?: number;
        ConStr?: string;
        Ctry?: any;
        State?: any;
        City?: any;
    }
}
